import { render, staticRenderFns } from "./DemoSection.vue?vue&type=template&id=e1492e4e&"
import script from "./DemoSection.vue?vue&type=script&lang=js&"
export * from "./DemoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports